import * as Mod1 from "./discourse/adapters/discourse-post-event-adapter";
import * as Mod2 from "./discourse/adapters/discourse-post-event-event";
import * as Mod3 from "./discourse/adapters/discourse-post-event-invitee";
import * as Mod4 from "./discourse/adapters/discourse-post-event-nested-adapter";
import * as Mod5 from "./discourse/adapters/discourse-post-event-reminder";
import * as Mod6 from "./discourse/admin-calendar-route-map";
import * as Mod7 from "./discourse/api-initializers/discourse-group-timezones";
import * as Mod8 from "./discourse/components/admin-holidays-list-item";
import * as Mod9 from "./discourse/components/admin-holidays-list";
import * as Mod10 from "./discourse/components/bulk-invite-sample-csv-file";
import * as Mod11 from "./discourse/components/category-calendar";
import * as Mod12 from "./discourse/components/compact-event-editor";
import * as Mod13 from "./discourse/components/composer-event-editor";
import * as Mod14 from "./discourse/components/csv-uploader";
import * as Mod15 from "./discourse/components/discourse-post-event/calendar-prompt";
import * as Mod16 from "./discourse/components/discourse-post-event/chat-channel";
import * as Mod17 from "./discourse/components/discourse-post-event/creator";
import * as Mod18 from "./discourse/components/discourse-post-event/dates";
import * as Mod19 from "./discourse/components/discourse-post-event/description";
import * as Mod20 from "./discourse/components/discourse-post-event/event-status";
import * as Mod21 from "./discourse/components/discourse-post-event/image";
import * as Mod22 from "./discourse/components/discourse-post-event/index";
import * as Mod23 from "./discourse/components/discourse-post-event/invitee";
import * as Mod24 from "./discourse/components/discourse-post-event/invitees";
import * as Mod25 from "./discourse/components/discourse-post-event/livestream";
import * as Mod26 from "./discourse/components/discourse-post-event/location";
import * as Mod27 from "./discourse/components/discourse-post-event/more-menu";
import * as Mod28 from "./discourse/components/discourse-post-event/onebox-node-view";
import * as Mod29 from "./discourse/components/discourse-post-event/onebox-preview";
import * as Mod30 from "./discourse/components/discourse-post-event/status";
import * as Mod31 from "./discourse/components/discourse-post-event/url";
import * as Mod32 from "./discourse/components/event-date";
import * as Mod33 from "./discourse/components/event-node-view";
import * as Mod34 from "./discourse/components/full-calendar";
import * as Mod35 from "./discourse/components/group-timezones/index";
import * as Mod36 from "./discourse/components/group-timezones/new-day";
import * as Mod37 from "./discourse/components/group-timezones/time-traveller";
import * as Mod38 from "./discourse/components/group-timezones/timezone";
import * as Mod39 from "./discourse/components/livestream/embeddable-chat-channel";
import * as Mod40 from "./discourse/components/livestream/mobile-livestream-chat-icon";
import * as Mod41 from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
import * as Mod42 from "./discourse/components/livestream/responsive-livestream-chat-icon";
import * as Mod43 from "./discourse/components/livestream/zoom-entry";
import * as Mod44 from "./discourse/components/livestream/zoom-page";
import * as Mod45 from "./discourse/components/modal/post-event-builder";
import * as Mod46 from "./discourse/components/modal/post-event-bulk-invite";
import * as Mod47 from "./discourse/components/modal/post-event-invite-user-or-group";
import * as Mod48 from "./discourse/components/modal/post-event-invitees/index";
import * as Mod49 from "./discourse/components/modal/post-event-invitees/user";
import * as Mod50 from "./discourse/components/post-calendar";
import * as Mod51 from "./discourse/components/region-input";
import * as Mod52 from "./discourse/components/toggle-invitees";
import * as Mod53 from "./discourse/components/upcoming-events-calendar";
import * as Mod54 from "./discourse/components/upcoming-events-list";
import * as Mod55 from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
import * as Mod56 from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
import * as Mod57 from "./discourse/connectors/calendar-preferences/discourse-events-preferences.gjs";
import * as Mod58 from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
import * as Mod59 from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
import * as Mod60 from "./discourse/connectors/chat-channel-card-cta/livestream-rsvp.gjs";
import * as Mod61 from "./discourse/connectors/chat-channel-preview-card-content/livestream-rsvp.gjs";
import * as Mod62 from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
import * as Mod63 from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
import * as Mod64 from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
import * as Mod65 from "./discourse/connectors/user-custom-preferences/region.gjs";
import * as Mod66 from "./discourse/controllers/admin-plugins/show/discourse-events-holidays";
import * as Mod67 from "./discourse/controllers/discourse-post-event-upcoming-events";
import * as Mod68 from "./discourse/controllers/discourse-post-event-upcoming-events/index";
import * as Mod69 from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
import * as Mod70 from "./discourse/discourse-calendar-topic-zoom-route-map";
import * as Mod71 from "./discourse/discourse-event-upcoming-events-route-map";
import * as Mod72 from "./discourse/helpers/format-event-name";
import * as Mod73 from "./discourse/helpers/format-future-date";
import * as Mod74 from "./discourse/initializers/add-create-event-composer-action";
import * as Mod75 from "./discourse/initializers/add-event-ui-builder";
import * as Mod76 from "./discourse/initializers/add-events-create-topic-button";
import * as Mod77 from "./discourse/initializers/add-upcoming-events-to-sidebar";
import * as Mod78 from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
import * as Mod79 from "./discourse/initializers/disable-sort";
import * as Mod80 from "./discourse/initializers/discourse-calendar";
import * as Mod81 from "./discourse/initializers/discourse-post-event-decorator";
import * as Mod82 from "./discourse/initializers/event-relative-date";
import * as Mod83 from "./discourse/initializers/event-user-options";
import * as Mod84 from "./discourse/initializers/livestream-chat-overrides";
import * as Mod85 from "./discourse/lib/add-event-to-calendar";
import * as Mod86 from "./discourse/lib/calendar-locale";
import * as Mod87 from "./discourse/lib/calendar-view-helper";
import * as Mod88 from "./discourse/lib/colors";
import * as Mod89 from "./discourse/lib/constants";
import * as Mod90 from "./discourse/lib/discourse-markdown/discourse-calendar";
import * as Mod91 from "./discourse/lib/discourse-markdown/discourse-post-event-block";
import * as Mod92 from "./discourse/lib/discourse-markdown/livestream-preview";
import * as Mod93 from "./discourse/lib/event-preview";
import * as Mod94 from "./discourse/lib/event-recurrence";
import * as Mod95 from "./discourse/lib/event-relative-date";
import * as Mod96 from "./discourse/lib/format-event-for-calendar";
import * as Mod97 from "./discourse/lib/full-calendar-default-options";
import * as Mod98 from "./discourse/lib/guess-best-date-format";
import * as Mod99 from "./discourse/lib/livestream-rsvp";
import * as Mod100 from "./discourse/lib/livestream-utils";
import * as Mod101 from "./discourse/lib/open-event-composer";
import * as Mod102 from "./discourse/lib/raw-event-helper";
import * as Mod103 from "./discourse/lib/regions";
import * as Mod104 from "./discourse/lib/round-time";
import * as Mod105 from "./discourse/lib/zoom-frame-url";
import * as Mod106 from "./discourse/models/discourse-post-event-event-stats";
import * as Mod107 from "./discourse/models/discourse-post-event-event";
import * as Mod108 from "./discourse/models/discourse-post-event-invitee";
import * as Mod109 from "./discourse/models/discourse-post-event-invitees";
import * as Mod110 from "./discourse/models/discourse-post-event-reminder";
import * as Mod111 from "./discourse/modifiers/dismiss-keyboard-on-chat-send";
import * as Mod112 from "./discourse/modifiers/open-links-in-new-tab";
import * as Mod113 from "./discourse/modifiers/zoom-page-viewport-fit";
import * as Mod114 from "./discourse/pre-initializers/rich-editor-extension";
import * as Mod115 from "./discourse/pre-initializers/transformers";
import * as Mod116 from "./discourse/routes/discourse-post-event-upcoming-events";
import * as Mod117 from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
import * as Mod118 from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
import * as Mod119 from "./discourse/routes/discourse-post-event-upcoming-events/index";
import * as Mod120 from "./discourse/routes/discourse-post-event-upcoming-events/mine";
import * as Mod121 from "./discourse/routes/topic-zoom";
import * as Mod122 from "./discourse/services/create-event-composer";
import * as Mod123 from "./discourse/services/discourse-post-event-api";
import * as Mod124 from "./discourse/services/discourse-post-event-service";
import * as Mod125 from "./discourse/services/embeddable-chat";
import * as Mod126 from "./discourse/services/post-calendar";
import * as Mod127 from "./discourse/templates/admin-plugins/show/discourse-events-holidays";
import * as Mod128 from "./discourse/templates/discourse-post-event-upcoming-events";
import * as Mod129 from "./discourse/templates/discourse-post-event-upcoming-events/index";
import * as Mod130 from "./discourse/templates/discourse-post-event-upcoming-events/mine";
import * as Mod131 from "./discourse/templates/topic-zoom";
const compatModules = {
  "discourse/adapters/discourse-post-event-adapter": Mod1,
  "discourse/adapters/discourse-post-event-event": Mod2,
  "discourse/adapters/discourse-post-event-invitee": Mod3,
  "discourse/adapters/discourse-post-event-nested-adapter": Mod4,
  "discourse/adapters/discourse-post-event-reminder": Mod5,
  "discourse/admin-calendar-route-map": Mod6,
  "discourse/api-initializers/discourse-group-timezones": Mod7,
  "discourse/components/admin-holidays-list-item": Mod8,
  "discourse/components/admin-holidays-list": Mod9,
  "discourse/components/bulk-invite-sample-csv-file": Mod10,
  "discourse/components/category-calendar": Mod11,
  "discourse/components/compact-event-editor": Mod12,
  "discourse/components/composer-event-editor": Mod13,
  "discourse/components/csv-uploader": Mod14,
  "discourse/components/discourse-post-event/calendar-prompt": Mod15,
  "discourse/components/discourse-post-event/chat-channel": Mod16,
  "discourse/components/discourse-post-event/creator": Mod17,
  "discourse/components/discourse-post-event/dates": Mod18,
  "discourse/components/discourse-post-event/description": Mod19,
  "discourse/components/discourse-post-event/event-status": Mod20,
  "discourse/components/discourse-post-event/image": Mod21,
  "discourse/components/discourse-post-event/index": Mod22,
  "discourse/components/discourse-post-event/invitee": Mod23,
  "discourse/components/discourse-post-event/invitees": Mod24,
  "discourse/components/discourse-post-event/livestream": Mod25,
  "discourse/components/discourse-post-event/location": Mod26,
  "discourse/components/discourse-post-event/more-menu": Mod27,
  "discourse/components/discourse-post-event/onebox-node-view": Mod28,
  "discourse/components/discourse-post-event/onebox-preview": Mod29,
  "discourse/components/discourse-post-event/status": Mod30,
  "discourse/components/discourse-post-event/url": Mod31,
  "discourse/components/event-date": Mod32,
  "discourse/components/event-node-view": Mod33,
  "discourse/components/full-calendar": Mod34,
  "discourse/components/group-timezones/index": Mod35,
  "discourse/components/group-timezones/new-day": Mod36,
  "discourse/components/group-timezones/time-traveller": Mod37,
  "discourse/components/group-timezones/timezone": Mod38,
  "discourse/components/livestream/embeddable-chat-channel": Mod39,
  "discourse/components/livestream/mobile-livestream-chat-icon": Mod40,
  "discourse/components/livestream/modal/mobile-embeddable-chat-modal": Mod41,
  "discourse/components/livestream/responsive-livestream-chat-icon": Mod42,
  "discourse/components/livestream/zoom-entry": Mod43,
  "discourse/components/livestream/zoom-page": Mod44,
  "discourse/components/modal/post-event-builder": Mod45,
  "discourse/components/modal/post-event-bulk-invite": Mod46,
  "discourse/components/modal/post-event-invite-user-or-group": Mod47,
  "discourse/components/modal/post-event-invitees/index": Mod48,
  "discourse/components/modal/post-event-invitees/user": Mod49,
  "discourse/components/post-calendar": Mod50,
  "discourse/components/region-input": Mod51,
  "discourse/components/toggle-invitees": Mod52,
  "discourse/components/upcoming-events-calendar": Mod53,
  "discourse/components/upcoming-events-list": Mod54,
  "discourse/connectors/before-main-outlet/embeddable-chat-channel-connector": Mod55,
  "discourse/connectors/before-topic-list-body/category-calendar": Mod56,
  "discourse/connectors/calendar-preferences/discourse-events-preferences": Mod57,
  "discourse/connectors/calendar-subscriptions-feeds/event-feeds": Mod58,
  "discourse/connectors/category-custom-settings/show-event-category-sorting-settings": Mod59,
  "discourse/connectors/chat-channel-card-cta/livestream-rsvp": Mod60,
  "discourse/connectors/chat-channel-preview-card-content/livestream-rsvp": Mod61,
  "discourse/connectors/discovery-list-container-top/category-events-calendar": Mod62,
  "discourse/connectors/header-topic-title-suffix/event-date-container": Mod63,
  "discourse/connectors/topic-list-after-title/event-badge": Mod64,
  "discourse/connectors/user-custom-preferences/region": Mod65,
  "discourse/controllers/admin-plugins/show/discourse-events-holidays": Mod66,
  "discourse/controllers/discourse-post-event-upcoming-events": Mod67,
  "discourse/controllers/discourse-post-event-upcoming-events/index": Mod68,
  "discourse/controllers/discourse-post-event-upcoming-events/mine": Mod69,
  "discourse/discourse-calendar-topic-zoom-route-map": Mod70,
  "discourse/discourse-event-upcoming-events-route-map": Mod71,
  "discourse/helpers/format-event-name": Mod72,
  "discourse/helpers/format-future-date": Mod73,
  "discourse/initializers/add-create-event-composer-action": Mod74,
  "discourse/initializers/add-event-ui-builder": Mod75,
  "discourse/initializers/add-events-create-topic-button": Mod76,
  "discourse/initializers/add-upcoming-events-to-sidebar": Mod77,
  "discourse/initializers/calendar-admin-plugin-configuration-nav": Mod78,
  "discourse/initializers/disable-sort": Mod79,
  "discourse/initializers/discourse-calendar": Mod80,
  "discourse/initializers/discourse-post-event-decorator": Mod81,
  "discourse/initializers/event-relative-date": Mod82,
  "discourse/initializers/event-user-options": Mod83,
  "discourse/initializers/livestream-chat-overrides": Mod84,
  "discourse/lib/add-event-to-calendar": Mod85,
  "discourse/lib/calendar-locale": Mod86,
  "discourse/lib/calendar-view-helper": Mod87,
  "discourse/lib/colors": Mod88,
  "discourse/lib/constants": Mod89,
  "discourse/lib/discourse-markdown/discourse-calendar": Mod90,
  "discourse/lib/discourse-markdown/discourse-post-event-block": Mod91,
  "discourse/lib/discourse-markdown/livestream-preview": Mod92,
  "discourse/lib/event-preview": Mod93,
  "discourse/lib/event-recurrence": Mod94,
  "discourse/lib/event-relative-date": Mod95,
  "discourse/lib/format-event-for-calendar": Mod96,
  "discourse/lib/full-calendar-default-options": Mod97,
  "discourse/lib/guess-best-date-format": Mod98,
  "discourse/lib/livestream-rsvp": Mod99,
  "discourse/lib/livestream-utils": Mod100,
  "discourse/lib/open-event-composer": Mod101,
  "discourse/lib/raw-event-helper": Mod102,
  "discourse/lib/regions": Mod103,
  "discourse/lib/round-time": Mod104,
  "discourse/lib/zoom-frame-url": Mod105,
  "discourse/models/discourse-post-event-event-stats": Mod106,
  "discourse/models/discourse-post-event-event": Mod107,
  "discourse/models/discourse-post-event-invitee": Mod108,
  "discourse/models/discourse-post-event-invitees": Mod109,
  "discourse/models/discourse-post-event-reminder": Mod110,
  "discourse/modifiers/dismiss-keyboard-on-chat-send": Mod111,
  "discourse/modifiers/open-links-in-new-tab": Mod112,
  "discourse/modifiers/zoom-page-viewport-fit": Mod113,
  "discourse/pre-initializers/rich-editor-extension": Mod114,
  "discourse/pre-initializers/transformers": Mod115,
  "discourse/routes/discourse-post-event-upcoming-events": Mod116,
  "discourse/routes/discourse-post-event-upcoming-events/default-index": Mod117,
  "discourse/routes/discourse-post-event-upcoming-events/default-mine": Mod118,
  "discourse/routes/discourse-post-event-upcoming-events/index": Mod119,
  "discourse/routes/discourse-post-event-upcoming-events/mine": Mod120,
  "discourse/routes/topic-zoom": Mod121,
  "discourse/services/create-event-composer": Mod122,
  "discourse/services/discourse-post-event-api": Mod123,
  "discourse/services/discourse-post-event-service": Mod124,
  "discourse/services/embeddable-chat": Mod125,
  "discourse/services/post-calendar": Mod126,
  "discourse/templates/admin-plugins/show/discourse-events-holidays": Mod127,
  "discourse/templates/discourse-post-event-upcoming-events": Mod128,
  "discourse/templates/discourse-post-event-upcoming-events/index": Mod129,
  "discourse/templates/discourse-post-event-upcoming-events/mine": Mod130,
  "discourse/templates/topic-zoom": Mod131,
};
export { compatModules };
export default compatModules;
